// DEC-051 / S-053-B4: 取引先マスタ（users/{uid}/companies）購読フック。
// 社名グルーピング表示・社名フィルタ・1タップ訂正の名前解決に使う。
import { useEffect, useMemo, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from './firebase';

export interface Company {
  id: string;
  name: string;
  aliases?: string[];
  kind?: string;
  meetingCount?: number;
}

// companyIds が空 / マスタ未解決の議事録を束ねる仮想カードの ID。
export const UNCLASSIFIED_ID = '__unclassified__';

export function useCompanies(uid?: string) {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) {
      setCompanies([]);
      setLoading(false);
      return;
    }
    const ref = collection(db, 'users', uid, 'companies');
    const unsubscribe = onSnapshot(
      ref,
      (snap) => {
        const data = snap.docs.map((d) => ({ id: d.id, ...(d.data() as any) } as Company));
        data.sort((a, b) => (a.name || '').localeCompare(b.name || '', 'ja'));
        setCompanies(data);
        setLoading(false);
      },
      (e: any) => {
        console.error('[useCompanies] failed to subscribe companies:', e);
        setLoading(false);
      }
    );
    return unsubscribe;
  }, [uid]);

  const companyMap = useMemo(
    () => Object.fromEntries(companies.map((c) => [c.id, c])) as Record<string, Company>,
    [companies]
  );

  return { companies, companyMap, loading };
}
